import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthRoutes, USERTYPES } from "../../constants/Constants";
import userContext from "../../context/users/UserContext";
import {
  changeUserStatus,
  getSupervisorList,
  changeUserLockStatus,
} from "../../service/UserService";
import NotAuthorized from "../../components/NotAuthorized";
import { SupervisorColumns } from "../../constants/Columns/Supervisor";
import {
  Checkbox,
  PrimaryButton,
  SearchBox,
} from "@fluentui/react";
import loaderContext from "../../context/loader/LoaderContext";
import {
  checkboxFilterStyle,
  searchStyle,
} from "../StudyList/helpers/ConstantStyles";
import { t } from "i18next";
import ListViewV3 from "../../components/ListViewV3/ListViewV3";
import PasswordResetModal from "../../components/PasswordResetModal/PasswordResetModal";

const SupervisorList = (props) => {
  const navigate = useNavigate();
  const [t, i18n] = useTranslation();
  const [updateCurrentPage, setUpdateCurrentPage] = useState(false);
  const [searchParams] = useSearchParams();
  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });
  const [firmsListForFilter, setFirmListForFilters] = useState([]);
  const [storeFirmsListForFilter, setStoreFirmsListForFilters] = useState([]);
  const [firmList, setFirmList] = useState([]);
  const [storeFirmList, setStoredFirmList] = useState([]);
  const [displayListAppliedFilter, setDisplayListAppliedFilter] = useState([]);
  const [dataQueryState, setDataQueryState] = useState({});
  const [selectedUsername, setSelectedUsername] = useState("");
  const [showResetModal, setShowResetModal] = useState(false);
  const [fullName,setFullName]=useState("");

  const { roles, authenticated, loadByUsername, userId, firmId } =
    useContext(userContext);
  const { setLoaderRunning, ref } = useContext(loaderContext);

  let firmID =
    props.firmId === undefined
      ? searchParams.get("firmId") != null
        ? searchParams.get("firmId")
        : firmId
      : props.firmId;

  function camelToUnderscore(key) {
    var result = key.replace(/([A-Z])/g, " $1");
    return result.split(" ").join("_").toLowerCase();
  }

  function handleCaching(data) {
    console.log("inside cache");
    setUpdateCurrentPage(!updateCurrentPage);
    setFilterObj({ ...filterObj, activeStatus: updateCurrentPage, row: data });
  }

  const handleActionButton = async (event, data, cell) => {
    event.stopPropagation();
    try {
      const response = await changeUserStatus(data);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        // handleCaching(data);
        ReloadData(data, true);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleLockButton = async (event, data, cell) => {
    event.stopPropagation();
    try {
      const response = await changeUserLockStatus(data);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        // handleCaching(data);
        ReloadData(data, false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleUserClick = async (cell) => {
    cell = cell.row.original;
    if (props.firmId === undefined) {
      navigate(
        AuthRoutes.MYVIEWUSER + "?id=" + cell.id + "&firmId=" + cell.firm.id,
        {}
      );
    } else {
      navigate(
        AuthRoutes.MYVIEWUSER +
          "?id=" +
          cell.id +
          "&firmId=" +
          cell.firm.id +
          "&for=firm",
        {}
      );
    }
  };

  function ReloadData(id, actionOrLocked) {
    // setUpdateCurrentPage(() => !updateCurrentPage);
    // setFilterObj({ ...filterObj, activeStatus: updateCurrentPage, row: data });
     let newIndex = -1;
     let newData = dataQueryState?.data?.rows.filter((row, index) => {
       if (row.id == id) {
         newIndex = index;
         return true;
       }
       return false;
     });  
     setDataQueryState(() => {
       const newValue = {
         ...dataQueryState
       };
       if(newValue.data.rows[newIndex] != null){
          if(actionOrLocked){
            newValue.data.rows[newIndex].active = !newValue.data.rows[newIndex].active;
          }else if(!actionOrLocked){
            newValue.data.rows[newIndex].accountNonLocked = !newValue.data.rows[newIndex].accountNonLocked;
          }
       }
       return newValue;
     });
 
   }

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, []);

   const openPasswordReset = (event,fullName,username) => {
    event.stopPropagation(); 
    setSelectedUsername(username);
    setShowResetModal(true);
    setFullName(fullName);
  };  
  const columns = SupervisorColumns(
    userId,
    handleActionButton,
    handleUserClick,
    handleLockButton,
    openPasswordReset
  );

  const options = [
    { key: "username", text: t("user.username") },
    { key: "firstName", text: t("user.first-name") },
    { key: "lastName", text: t("user.last-name") },
    { key: "email", text: t("user.email") },
    { key: "mobile", text: t("user.mobile") },
    { key: "active", text: t("user.action") },
  ];

  const buttonsTopBar = [
    {
      key: "1",
      button: (
        <Link
          key="1"
          to={
            props.firmId === undefined
              ? AuthRoutes.MYADDSUPERVISOR + "?firmId=" + firmId
              : AuthRoutes.MYADDSUPERVISOR + "?firmId=" + firmID + "&for=firm"
          }
        >
          <div className="add-button-list-view">
            {/* <AddButton  text={t("supervisor.add-supervisor")} /> */}
            <PrimaryButton
              text={t("supervisor.add-supervisor")}
              className={
                "common-default-active-button list-view-top-buttons-styles"
              }
            />
          </div>
        </Link>
      ),
    },
  ];

  const fetchData = async (options) => {
    // let page = options.pageIndex;
    // let pageSize = options.pageSize;
    let sortParams = "id";
    let sortyByDir = false;

    if (
      options.sortObj.sortFieldValue != undefined &&
      options.sortObj.sortFieldValue.length > 0
    ) {
      sortParams = options.sortObj.sortFieldValue;
      sortyByDir = options.sortObj.sortDir;
    }

    const body = {
      paginationDto: {
        pageNumber: options.page,
        pageSize: 10,
        sortField: camelToUnderscore(sortParams),
        sortOrder: sortyByDir,
        filterInput:
          options.filterObj.filterInput == null
            ? ""
            : options.filterObj.filterInput,
      },
      firmId: firmID,
      firmAccessList: Object.values(displayListAppliedFilter).map(
        (item) => item.value
      ),
    };

    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await getSupervisorList(body);
    let data = null;
    let pageCount = null;
    if (response.status === 200 && response.data.result === "SUCCESS") {
      setLoaderRunning(false);
      ref.current.complete();
      setFirmList(response.data.data.firmList);
      setStoredFirmList(response.data.data.firmList);
      data = response.data.data.userList;
      pageCount = response.data.data.totalPages;

      return {
        rows: data,
        pageCount: pageCount,
      };
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      return {
        rows: data,
        pageCount: pageCount,
      };
    }
  };

  const handleClearFilter = () => {
    setDisplayListAppliedFilter([]);
    setFirmListForFilters([]);
    setStoreFirmsListForFilters([]);
    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterInput = "";
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  const removeBadgeFromFilter = (toBeRemoveObj) => {
    setFirmListForFilters((current) =>
      current.filter((item) => item.label !== toBeRemoveObj.label)
    );
    setStoreFirmsListForFilters((current) =>
      current.filter((item) => item.label !== toBeRemoveObj.label)
    );

    setDisplayListAppliedFilter((current) =>
      current.filter((item) => item.label !== toBeRemoveObj.label)
    );

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  const handleApplyClick = (filterValue) => {
    if (filterValue != undefined) filterValue = filterValue.trim();
    setDisplayListAppliedFilter(firmsListForFilter);

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });
    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterInput = filterValue;
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  return (
    <>
       <PasswordResetModal
            username={selectedUsername}
            visible={showResetModal}
            onClose={() => setShowResetModal(false)}
            fullName={fullName}
          />
      {authenticated &&
        (roles[0] === USERTYPES.SUPERVISOR ||
          roles[0] === USERTYPES.ADMIN ||
          roles[0] === USERTYPES.FIRMADMIN) && (
          <div className="main-container-body">
            <ListViewV3
              buttonsTopBar={buttonsTopBar}
              sortDropdownOptions={options}
              fetchData={fetchData}
              columns={columns}
              handleUserClick={handleUserClick}
              filterObj={filterObj}
              setFilterObj={setFilterObj}
              sortObj={sortObj}
              setSortObj={setSortObj}
              setPagination={setPagination}
              paginationObj={paginationObj}
              uniqueKey={"Supervisor"}
              heading={t("navbar.supervisor")}
              handleApplyClick={handleApplyClick}
              displayListAppliedFilter={displayListAppliedFilter}
              handleClearFilter={handleClearFilter}
              removeBadgeFromFilter={removeBadgeFromFilter}
              placeholder={"Username"}
              showFilter={true}
              enhancedFilter={true}
              showSort={true}
              filterPopUpComponent={
                <FilterPopUpComponent
                  setFirmList={setFirmList}
                  firmList={firmList}
                  storeFirmList={storeFirmList}
                  firmsListForFilter={firmsListForFilter}
                  setFirmListForFilters={setFirmListForFilters}
                />
              }
              fullLength={props.fullLength}
              fullLengthForRow={props.fullLengthForRow}
              setDataQueryState={setDataQueryState}
              dataQueryState={dataQueryState}
            />
          </div>
        )}
      {roles.length != 0 && roles[0] === USERTYPES.RADIOLOGIST && (
        <NotAuthorized />
      )}
    </>
  );
};

export default SupervisorList;

export const FilterPopUpComponent = (props) => {
  const filterList = (searchInput) => {
    if (searchInput != null && searchInput != undefined)
      searchInput = searchInput.trim();
    let searchValue = searchInput.toLowerCase();
    let allTemp = props.storeFirmList;
    if (searchValue != "") {
      const filteredData = allTemp.filter((item) => {
        return item.name.toLowerCase().includes(searchValue);
      });
      props.setFirmList((prevFirmsList) => {
        return filteredData;
      });
    } else {
      props.setFirmList((prevFirmsList) => {
        return props.storeFirmList;
      });
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <div className="align-filter-section" style={{ width: "15%" }}>
        <span className="filter-section-text">{t("navbar.clients")}</span>
        <SearchBox
          placeholder="Search"
          styles={searchStyle}
          onClear={(ev) => {
            // console.log("Custom onClear Called");
          }}
          onChange={(ev, newValue) => {
            filterList(newValue);
          }}
        />
        <div
          className={`modal-scroll study-list-filter-section ${
            props.firmList?.length == 0 ? "no-result-container" : ""
          }`}
        >
          {props.firmList != undefined &&
            Array.from(props.firmList).map((firm) => {
              return (
                <Checkbox
                  key={firm.id}
                  label={firm.name}
                  name={firm.name}
                  styles={checkboxFilterStyle}
                  // defaultChecked = {searchDto.modalityIds?.includes(modality.id)}
                  checked={props.firmsListForFilter?.some(
                    (item) => item.value === firm.id
                  )}
                  onChange={(e, data) => {
                    if (data) {
                      console.log("-- check --");
                      props.setFirmListForFilters([
                        ...props.firmsListForFilter,
                        { label: firm.name, value: firm.id },
                      ]);
                    } else {
                      console.log("-- uncheck --");
                      props.setFirmListForFilters((current) =>
                        current.filter((item) => item.value !== firm.id)
                      );
                    }
                  }}
                />
              );
            })}
          {props.firmList != undefined && props.firmList?.length == 0 && (
            <div className="no-result-message">
              {t("search-message.no-result")}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
